import { forwardRef } from 'react'
import { Tooltip as MuiTooltip } from '@mui/material'

export const Tooltip = forwardRef(({ sx, ...props }, ref) => (
  <MuiTooltip ref={ref} {...props} sx={{ tooltip: '2rem', ...sx }} />
))
